export default __webpack_public_path__ + "static/media/banner-page-sncc-mobile.af94cd72.png";